/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DriveVerificationGovernmentId
 */
export interface DriveVerificationGovernmentId {
    /**
     * 
     * @type {string}
     * @memberof DriveVerificationGovernmentId
     */
    'id_type': DriveVerificationGovernmentIdIdTypeEnum;
    /**
     * ISO 3166 country code
     * @type {string}
     * @memberof DriveVerificationGovernmentId
     */
    'country_alpha_2_code': string;
    /**
     * The state or region of the ID
     * @type {string}
     * @memberof DriveVerificationGovernmentId
     */
    'territory': string;
    /**
     * The ID\'s number
     * @type {string}
     * @memberof DriveVerificationGovernmentId
     */
    'number': string;
}

export const DriveVerificationGovernmentIdIdTypeEnum = {
    us_drivers_license_passport: 'us_drivers_license passport'
} as const;

export type DriveVerificationGovernmentIdIdTypeEnum = typeof DriveVerificationGovernmentIdIdTypeEnum[keyof typeof DriveVerificationGovernmentIdIdTypeEnum];


